angular.module("coordinateBancarie.components", [])
    .component("coordinateBancarie", {
        templateUrl: "ng/components/coordinateBancarie/coordinateBancarie.view.html",
        bindings: {
            model: '<'
        },
        controller: CoordinateBancarieController,
        controllerAs: "coordinateBancarieCtrl"
    })

function CoordinateBancarieController(
) {
    var self = this;

    self.$onInit = function () {

    }


}